<template>
    <v-footer id="core-footer" v-bind="localAttrs" fixed>
        <span class="font-weight-light copyright">
            {{`Copyright &copy; ${(new Date()).getFullYear()}`}}
            
            <a href="https://intranetbr.sonda.com/" target="_blank">SONDA</a>
        </span>

        <span>
            <a @click="scrollUp">
                <v-icon>mdi-chevron-double-up</v-icon>
            </a>
            <a @click="scrollDown">
                <v-icon>mdi-chevron-double-down</v-icon>
            </a>            
        </span>        
    </v-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            link: null
        }
    },
    computed: {
        ...mapGetters("app", ["getUserCountry"]),
        localAttrs () {
            const attrs = {}

            attrs.class = "";
            if(this.$store.state.app.drawer)
                attrs.class = "v-footer-menu-active";

            return attrs
        }
    },
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
        this.setLocale(null);
    },
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },    
    methods:{     
        scrollUp(){
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        scrollDown(){
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        },        
        setLocale(locale){
            if(locale != null){
                switch(locale){
                    case process.env.VUE_APP_DB_LOCALE_ES:
                        this.link = "/";        
                        break;

                    case process.env.VUE_APP_DB_LOCALE_EN:
                        this.link = "/";        
                        break;

                    default:
                        this.link = "/";        
                        break;                    
                } 
            }
            else 
                this.link = "/";        
        },           
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/material-dashboard/variables";

</style>
